import x from "../../../assets/images/X.png";
import back from "../../../assets/images/back.png";

import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import Search1 from "../../../assets/images/Search1.png";
import Previous from "../../../assets/images/Previous.png";

import { useLocation, useNavigate } from "react-router-dom";
import { SetTypeMenuSub } from "../../../features/TopSearches/TopSearchesSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import {
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
  SortProducts,
} from "../../../features/Products/ProductSlice";
import NotificationModal from "../NotificationModal";
import SeacrhMenuDrops from "./SeacrhMenuDrops";
import SeacrhMenuWomen from "./SeacrhMenuWomen";
import SeacrhMenuMen from "./SeacrhMenuMen";
import SeacrhMenuBags from "./SeacrhMenuBags";
import SeacrhMenuShoes from "./SeacrhMenuShoes";
import SeacrhMenuVintage from "./SeacrhMenuVintage";

function SearchMenuSection2({
  show,
  setShow,
  id,
  type,
  setType,
  setShowfirst,
}) {
  const { i18n, t } = useTranslation();
  const { subtype } = useSelector((store) => store.topsearches);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sq, setsq] = useState("");

  let parametres = new URLSearchParams(useLocation().search);

  const [showsectiondrops, setShowSectiondrops] = useState(false);
  const [showsectionwomen, setShowSectionWomen] = useState(false);
  const [showsectionmen, setShowSectionMen] = useState(false);
  const [showsectionBags, setShowSectionBags] = useState(false);
  const [showsectionshoes, setShowSectionShoes] = useState(false);
  const [showsectionvintage, setShowSectionVintage] = useState(false);

  return (
    <>
      {showsectiondrops && (
        <SeacrhMenuDrops
          show={showsectiondrops}
          setShow={setShowSectiondrops}
          type={subtype}
          setShowbefore={setShow}
          setShowfirst={setShowfirst}
        />
      )}
      {showsectionwomen && (
        <SeacrhMenuWomen
          show={showsectionwomen}
          setShow={setShowSectionWomen}
          type={subtype}
          setShowbefore={setShow}
          setShowfirst={setShowfirst}
        />
      )}
      {showsectionmen && (
        <SeacrhMenuMen
          show={showsectionmen}
          setShow={setShowSectionMen}
          type={subtype}
          setShowbefore={setShow}
          setShowfirst={setShowfirst}
        />
      )}
      {showsectionBags && (
        <SeacrhMenuBags
          show={showsectionBags}
          setShow={setShowSectionBags}
          type={subtype}
          setShowbefore={setShow}
          setShowfirst={setShowfirst}
        />
      )}
      {showsectionshoes && (
        <SeacrhMenuShoes
          show={showsectionshoes}
          setShow={setShowSectionShoes}
          type={subtype}
          setShowbefore={setShow}
          setShowfirst={setShowfirst}
        />
      )}
      {showsectionvintage && (
        <SeacrhMenuVintage
          show={showsectionvintage}
          setShow={setShowSectionVintage}
          type={subtype}
          setShowbefore={setShow}
          setShowfirst={setShowfirst}
        />
      )}
      <Modal
        // className="modal fade"
        // id="SignUp"
        // tabIndex="-1"
        // role="dialog"
        // aria-labelledby="SignUp"
        show={show}
        fullscreen
        className="modal fade mx-0 px-0"
      >
        {/* <div
          className="modal-dialog modal-dialog-centered modal-signup"
          role="document"
        > */}
        <Modal.Body className="p-0 m-0 ">
          <div className="modal-header justify-content-between align-items-center d-flex pb-0 px-4">
            <div style={{ cursor: "pointer" }}>
              <img
                alt="main"
                src={back}
                onClick={() => setShow(false)}
                className={` ${
                  i18n.language == "en" ? "Previous" : "PreviousAr"
                }`}
              />
            </div>
            <button
              type="button"
              className="close close-txt close-modal align-items-center px-0"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setShow(false)}
            >
              <img
                alt="main"
                src={x}
                onClick={() => setShow(false)}
                className="x-close  mb-1"
              />

              {/* <img src={closeModal} onClick={()=>setShow(false)} className="ms-1 mb-1 close-btn2"/> */}
            </button>
          </div>

          <div className="modal-body px-4">
            {type == "newdrops" && (
              <>
                <div
                  className="w-100 pt-2  px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShow(false) & setShowfirst(false)}
                >
                  <div
                    className="searchmenutitle"
                    style={{ textTransform: "uppercase" }}
                    onClick={() =>
                      setShowSectiondrops(true) &
                      dispatch(SetTypeMenuSub("newArrival"))
                    }
                  >
                    {t("New Arrivals")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 pt-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectiondrops(true) &
                    dispatch(SetTypeMenuSub("Women"))
                  }
                >
                  <div className="searchmenu">{t("Women")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>
                <div
                  className="w-100 pb-4  px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectiondrops(true) & dispatch(SetTypeMenuSub("Men"))
                  }
                >
                  <div className="searchmenu">{t("Men")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>
                {/* <div
                                    className="w-100   px-0 align-items-center d-flex justify-content-between"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setShowSectiondrops(true)&dispatch(SetTypeMenuSub('Kids'))}
                                >

                                    <div className="searchmenu"  >
                                        {t("Kids")}
                                    </div>
                                    <div>
                                        <img src={Previous} alt="Previous" className={` ${i18n.language=="en"?"Previous":"PreviousAr"}`} />
                                    </div>
                                </div> */}
              </>
            )}

            {type == "Women" && (
              <>
                <div
                  className="w-100 pt-2  px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShow(false) & setShowfirst(false)}
                >
                  <div
                    className="searchmenutitle"
                    onClick={() =>
                      navigate("/products?gender=WFA967se7qX0jYtySgTj")
                    }
                    style={{ textTransform: "uppercase" }}
                  >
                    {t("Women")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 pt-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectionWomen(true) &
                    dispatch(SetTypeMenuSub("Clothes"))
                  }
                >
                  <div className="searchmenu">{t("Clothes")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>
                <div
                  className="w-100 pb-4   px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectionWomen(true) &
                    dispatch(SetTypeMenuSub("Shoes"))
                  }
                >
                  <div className="searchmenu">{t("Shoes")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>

                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectionWomen(true) & dispatch(SetTypeMenuSub("Bags"))
                  }
                >
                  <div className="searchmenu">{t("Bags")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>

                <div
                  className="w-100 pb-4  px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectionWomen(true) &
                    dispatch(SetTypeMenuSub("Accessories"))
                  }
                >
                  <div className="searchmenu">{t("Accessories")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>

                <div
                  className="w-100   px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectionWomen(true) &
                    dispatch(SetTypeMenuSub("watchesandJewelry"))
                  }
                >
                  <div className="searchmenu">{t("watchesandJewelry")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>
              </>
            )}

            {type == "Men" && (
              <>
                <div
                  className="w-100 pt-2  px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShow(false) & setShowfirst(false)}
                >
                  <div
                    className="searchmenutitle"
                    onClick={() =>
                      navigate("/products?gender=KG3s4pPk3arcBux5ERnD")
                    }
                    style={{ textTransform: "uppercase" }}
                  >
                    {t("Men")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 pt-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectionMen(true) &
                    dispatch(SetTypeMenuSub("Clothes"))
                  }
                >
                  <div className="searchmenu">{t("Clothes")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>
                <div
                  className="w-100 pb-4   px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectionMen(true) & dispatch(SetTypeMenuSub("Shoes"))
                  }
                >
                  <div className="searchmenu">{t("Shoes")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>

                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectionMen(true) & dispatch(SetTypeMenuSub("Bags"))
                  }
                >
                  <div className="searchmenu">{t("Bags")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>

                <div
                  className="w-100 pb-4  px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectionMen(true) &
                    dispatch(SetTypeMenuSub("Accessories"))
                  }
                >
                  <div className="searchmenu">{t("Accessories")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>

                <div
                  className="w-100   px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectionMen(true) &
                    dispatch(SetTypeMenuSub("watchesandJewelry"))
                  }
                >
                  <div className="searchmenu">{t("watchesandJewelry")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>
              </>
            )}

            {type == "Bags" && (
              <>
                <div
                  className="w-100 pt-2  px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShow(false) & setShowfirst(false)}
                >
                  <div
                    className="searchmenutitle"
                    onClick={() =>
                      navigate("/products?id=AqFLulu9y2m4mqEIkch1")
                    }
                    style={{ textTransform: "uppercase" }}
                  >
                    {t("Bags")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 pt-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectionBags(true) &
                    dispatch(SetTypeMenuSub("Designers"))
                  }
                >
                  <div className="searchmenu">{t("Designers")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>
                <div
                  className="w-100 pb-4   px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectionBags(true) &
                    dispatch(SetTypeMenuSub("Timeless Models"))
                  }
                >
                  <div className="searchmenu">{t("Timeless Models")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>

                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectionBags(true) & dispatch(SetTypeMenuSub("Women"))
                  }
                >
                  <div className="searchmenu">{t("Women")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>

                <div
                  className="w-100 pb-4  px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectionBags(true) & dispatch(SetTypeMenuSub("Men"))
                  }
                >
                  <div className="searchmenu">{t("Men")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>
              </>
            )}
            {type == "Shoes" && (
              <>
                <div
                  className="w-100 pt-4 pb-4  px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShow(false) & setShowfirst(false)}
                >
                  <div
                    className="searchmenutitle"
                    onClick={() =>
                      navigate("/products?id=WJmwaMSWxtl1dK1sPZ1x")
                    }
                    style={{ textTransform: "uppercase" }}
                  >
                    {t("Shoes")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectionShoes(true) &
                    dispatch(SetTypeMenuSub("Designers"))
                  }
                >
                  <div className="searchmenu">{t("Designers")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>
                <div
                  className="w-100  pb-4  px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectionShoes(true) &
                    dispatch(SetTypeMenuSub("Women"))
                  }
                >
                  <div className="searchmenu">{t("Women")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>
                <div
                  className="w-100 pb-4   px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectionShoes(true) & dispatch(SetTypeMenuSub("Men"))
                  }
                >
                  <div className="searchmenu">{t("Men")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>

                {/* <div
                                    className="w-100 pb-4   px-0 align-items-center d-flex justify-content-between"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setShowSectionShoes(true) & dispatch(SetTypeMenuSub('Kids'))}
                                >

                                    <div className="searchmenu"  >
                                        {t("Kids")}
                                    </div>
                                    <div>
                                        <img src={Previous} alt="Previous" className={` ${i18n.language=="en"?"Previous":"PreviousAr"}`} />
                                    </div>
                                </div> */}
              </>
            )}
            {type == "vintage" && (
              <>
                <div
                  className="w-100 pt-4 pb-4  px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShow(false) & setShowfirst(false)}
                >
                  <div
                    className="searchmenutitle"
                    onClick={() => navigate("/products?topic=Vintage")}
                    style={{ textTransform: "uppercase" }}
                  >
                    {t("vintage")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectionVintage(true) &
                    dispatch(SetTypeMenuSub("Designers"))
                  }
                >
                  <div className="searchmenu">{t("Designers")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>
                <div
                  className="w-100  pb-4  px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectionVintage(true) &
                    dispatch(SetTypeMenuSub("Women"))
                  }
                >
                  <div className="searchmenu">{t("Women")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>
                <div
                  className="w-100 pb-4   px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShowSectionVintage(true) &
                    dispatch(SetTypeMenuSub("Men"))
                  }
                >
                  <div className="searchmenu">{t("Men")}</div>
                  <div>
                    <img
                      src={Previous}
                      alt="Previous"
                      className={` ${
                        i18n.language == "en" ? "Previous" : "PreviousAr"
                      }`}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SearchMenuSection2;
